import * as trackingModules from './trackingModules';

export const getInstance = () => {
    const instance = typeof window !== 'undefined' && window.BookingFlowTracker ? window.BookingFlowTracker : null;
    return instance;
};

export const renderTrackingModulesScripts = (enabledTrackingModules, isMultiProperty, propertyCode, usingCookiePolicy) => {
    if (!enabledTrackingModules) {
        return null;
    }
    const script = document.createElement('script');
    script.innerHTML = `window.enabledTrackingModules = ${JSON.stringify(enabledTrackingModules)}`;
    script.id = 'enabled-tracking-modules-script';

    return (
        document.body.appendChild(script)
        && enabledTrackingModules.map((moduleParams) => {
            const TrackingModule = trackingModules[moduleParams.trackingModuleId];
            return TrackingModule ? TrackingModule.getScript(moduleParams, isMultiProperty, propertyCode, usingCookiePolicy) : null;
        })

    );
};

export const pushOnCookiePolicyAcepted = (propertyCode, isProduction) =>
    trackingModules.seekda.pushOnCookiePolicyAcepted(propertyCode, isProduction);

export const trackEvent = (eventName, eventData, onlyOnce = false) => {
    const bookingFlowTrackerInstance = getInstance();
    if (bookingFlowTrackerInstance && eventData) {
        const eventDataCloned = Object.assign({}, eventData);

        bookingFlowTrackerInstance.tracker.trackEvent({
            type : eventName,
            data : { eventData: eventDataCloned, onlyOnce },
        });
    }
};
